import React from "react";
import { CTAButton } from "./CTAButton";
import { IMAGES } from "../src/config";
export function FinalCTA() {
  return <section className="relative w-full overflow-hidden py-20" data-id="element-98" data-mp="3udyj7vx22vmq">
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url(${IMAGES.heroBg})`
    }} aria-hidden="true" data-id="element-99" data-mp="c70yncel7jpm" />
      <div className="absolute inset-0 bg-[#0a0a1f]/90" aria-hidden="true" data-id="element-100" data-mp="87jqgb7s08gr" />
      <div className="relative mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-101" data-mp="m3400g1m7ebi">
        <h2 className="font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-102" data-mp="h52gxv46vf01">
          ¿Y si no compras?
        </h2>
        <p className="mt-4 text-slate-300" data-id="element-103" data-mp="vwktfixuaren">
          Mañana el dólar habrá subido otra vez. Seguirás compitiendo por clientes
          que piden rebajas y te pagan poco. O puedes invertir hoy el costo de un
          café y empezar a{" "}
          <span className="font-semibold text-white" data-id="element-104" data-mp="zx4qynmbrx1b">
            facturar en moneda fuerte.
          </span>{" "}
          La decisión es tuya.
        </p>
        <p className="mt-4 font-display text-xl font-bold text-violet-300" data-id="element-105" data-mp="2c7107tri8hsr">
          Estás a un clic de cambiar tu moneda de pago.
        </p>
        <CTAButton className="mt-8" subtext="Garantía incondicional de 7 días · Sin riesgo" data-id="element-106" data-mp="2m2ks852y6wc8" />
      </div>
    </section>;
}